import React from 'react';
import { Heading, Stack, SystemStyleObject } from '@telescope/cassini-ui';
import { useCountdown, TimeUnit } from '@telescope/cassini-hooks';
import { TimeStat, TimeStatLabel, TimeStatValue } from 'components';

type CountdownData = {
  content: {
    description: string;
    labels: Record<TimeUnit, { singular: string; plural: string }>;
  };
  settings: {
    countdownUnits: Record<TimeUnit, boolean>;
    countdownTarget: number;
  };
  styles?: {
    description?: SystemStyleObject;
    container?: SystemStyleObject;
    timeStat?: {
      root?: SystemStyleObject;
      value?: SystemStyleObject;
      label?: SystemStyleObject;
    };
  };
};

export const Countdown = ({ content, settings, styles = {} }: CountdownData) => {
  const endDate = new Date(settings.countdownTarget);
  const countdown = useCountdown(endDate, { units: settings.countdownUnits });

  return (
    <>
      <Heading
        as="h2"
        size="sm"
        mb={4}
        fontWeight={400}
        fontFamily="body"
        fontSize={{ base: 'md', sm: 'lg' }}
        sx={styles.description}>
        {content.description}
      </Heading>
      <Stack
        _empty={{ display: 'none' }}
        direction={'row'}
        alignSelf="stretch"
        justifyContent={'space-between'}
        mb={9}
        sx={styles.container}>
        {(Object.keys(settings.countdownUnits) as TimeUnit[])
          .filter((key) => settings.countdownUnits[key])
          .map((key) => {
            const value = countdown[key];
            const label = content.labels[key][value === 1 ? 'singular' : 'plural'];
            return (
              <TimeStat key={key} sx={styles.timeStat?.root}>
                <TimeStatValue sx={styles.timeStat?.value}> {value} </TimeStatValue>
                <TimeStatLabel sx={styles.timeStat?.label}> {label} </TimeStatLabel>
              </TimeStat>
            );
          })}
      </Stack>
    </>
  );
};
